var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("PermissionSimplePage", {
        attrs: { permission: _vm.hasViewPermission }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasViewPermission,
              expression: "hasViewPermission"
            }
          ],
          staticClass: "main-body"
        },
        [
          _c("div", { staticClass: "main-dialog" }, [
            _c(
              "div",
              { attrs: { id: "card-container" } },
              [
                _c("div", { staticClass: "input-form" }, [
                  _c("div", { staticClass: "card-design" }, [
                    _c("div", [
                      _c("div", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.$t("system.user.query")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "all-forms" }, [
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("SMS.name")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  placeholder: _vm.$t("SMS.pleaseChoose"),
                                  clearable: "",
                                  filterable: ""
                                },
                                model: {
                                  value: _vm.listQuery.agentName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.listQuery, "agentName", $$v)
                                  },
                                  expression: "listQuery.agentName"
                                }
                              },
                              _vm._l(_vm.agentOption, function(item) {
                                return _c("el-option", {
                                  key: item.agentId,
                                  attrs: {
                                    label: item.agentName,
                                    value: item.agentName
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("SMS.username")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "filter-item",
                              attrs: {
                                clearable: "",
                                placeholder: _vm.$t("SMS.pleaseEnterText")
                              },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleFilter($event)
                                }
                              },
                              model: {
                                value: _vm.listQuery.agentAccount,
                                callback: function($$v) {
                                  _vm.$set(_vm.listQuery, "agentAccount", $$v)
                                },
                                expression: "listQuery.agentAccount"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("SMS.status")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  placeholder: _vm.$t("SMS.pleaseChoose"),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.listQuery.stateCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.listQuery, "stateCode", $$v)
                                  },
                                  expression: "listQuery.stateCode"
                                }
                              },
                              _vm._l(_vm.statusOptions, function(item) {
                                return _c("el-option", {
                                  key: item.key,
                                  attrs: {
                                    label: item.display_name,
                                    value: item.key
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("SMS.forceBindGoogleText")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  placeholder: _vm.$t("SMS.pleaseChoose"),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.listQuery.isGoogle,
                                  callback: function($$v) {
                                    _vm.$set(_vm.listQuery, "isGoogle", $$v)
                                  },
                                  expression: "listQuery.isGoogle"
                                }
                              },
                              _vm._l(_vm.forceBindGoogleOption, function(item) {
                                return _c("el-option", {
                                  key: item.key,
                                  attrs: {
                                    label: item.display_name,
                                    value: item.key
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "searchButton" },
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.hasViewPermission,
                                expression: "hasViewPermission"
                              }
                            ],
                            staticClass: "filter-item",
                            attrs: {
                              plain: _vm.$store.getters.plainConf,
                              type: "info",
                              icon: "el-icon-search"
                            },
                            on: { click: _vm.handleFilter }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("common.search")) +
                                "\n              "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "actions" }, [
                  _c(
                    "div",
                    { staticClass: "otherActions" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasPermissionEx("resetPassword"),
                              expression: "hasPermissionEx('resetPassword')"
                            }
                          ],
                          staticClass: "filter-item",
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "info",
                            icon: "el-icon-refresh"
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleResetPassword("resetPassword")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("common.resetPassword")) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasPermissionEx("menuLimitUpdate"),
                              expression: "hasPermissionEx('menuLimitUpdate')"
                            }
                          ],
                          staticClass: "filter-item",
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "info",
                            icon: "el-icon-edit"
                          },
                          on: { click: _vm.handleBatchUpdatePermission }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("common.batchUpdatePermissionText")
                              ) +
                              "\n            "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "addEditOrDelete" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasAddPermission,
                              expression: "hasAddPermission"
                            }
                          ],
                          staticClass: "filter-item",
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "success",
                            icon: "el-icon-plus"
                          },
                          on: { click: _vm.handleCreate }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("common.add")) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasDeletePermission,
                              expression: "hasDeletePermission"
                            }
                          ],
                          staticClass: "filter-item",
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "danger",
                            icon: "el-icon-delete"
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleDelete("delete")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("common.cancelUser")) +
                              "\n            "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.listLoading,
                        expression: "listLoading"
                      },
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasViewPermission,
                        expression: "hasViewPermission"
                      }
                    ],
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.list,
                      stripe: _vm.$store.getters.stripeConf,
                      border: _vm.$store.getters.borderConf
                    },
                    on: { "selection-change": _vm.handleSelectionChange }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "selection",
                        label: "",
                        align: "center",
                        width: "45",
                        fixed: ""
                      }
                    }),
                    _vm._v(" "),
                    _vm.$store.getters.isAdmin
                      ? _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("SMS.upAgentId"),
                            align: "center",
                            fixed: "",
                            "min-width": _vm.customTableColumnWidth("sm")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          content: _vm.convertUpAgentName(
                                            scope.row.upAgentId
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "ellipsis",
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.convertUpAgentName(
                                                  scope.row.upAgentId
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3557257567
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.name"),
                        align: "center",
                        fixed: "",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.agentName
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.agentName))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.username"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.agentAccount
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.agentAccount))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.frozenAmount"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.processFrozenAmount
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(scope.row.processFrozenAmount)
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.uncreditedAmount"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.processUncreditedAmount
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.processUncreditedAmount
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.amountOfProfit"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.processAvailableAmount
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(scope.row.processAvailableAmount)
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.userStatus"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: _vm.convertStatusName(
                                      scope.row.stateCode
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.convertStatusName(
                                            scope.row.stateCode
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.forceBindGoogleText"),
                        align: "center",
                        width: _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: _vm.convertForceGoogleOptionName(
                                      scope.row.isGoogle
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.convertForceGoogleOptionName(
                                            scope.row.isGoogle
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.isStoredGoogleText"),
                        align: "center",
                        width: _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: _vm.convertGoogleStatusOptionName(
                                      scope.row.isStoredGoogle
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.convertGoogleStatusOptionName(
                                            scope.row.isStoredGoogle
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.numberOfFailedLogins"),
                        align: "center",
                        width: _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.loginFaildCount))
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("common.createTimeText"),
                        align: "center",
                        width: _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.createDate
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.createDate))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.operating"),
                        width: "700",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasUpdatePermission,
                                      expression: "hasUpdatePermission"
                                    }
                                  ],
                                  attrs: {
                                    round: _vm.$store.getters.roundConf,
                                    type: "warning",
                                    size: "mini",
                                    icon: "el-icon-edit",
                                    plain: _vm.$store.getters.plainConf
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleUpdate(row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("common.edit")) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasPermissionEx("costUpdates"),
                                      expression:
                                        "hasPermissionEx('costUpdates')"
                                    }
                                  ],
                                  attrs: {
                                    round: _vm.$store.getters.roundConf,
                                    type: "warning",
                                    size: "mini",
                                    plain: _vm.$store.getters.plainConf
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleCost(row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("common.cost")) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasPermissionEx(
                                        "menuLimitUpdate"
                                      ),
                                      expression:
                                        "hasPermissionEx('menuLimitUpdate')"
                                    }
                                  ],
                                  attrs: {
                                    round: _vm.$store.getters.roundConf,
                                    type: "info",
                                    size: "mini",
                                    plain: _vm.$store.getters.plainConf
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleUpdatePermission(row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("common.permission")) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasPermissionEx("google:key"),
                                      expression:
                                        "hasPermissionEx('google:key')"
                                    }
                                  ],
                                  attrs: {
                                    round: _vm.$store.getters.roundConf,
                                    type: "info",
                                    size: "mini",
                                    plain: _vm.$store.getters.plainConf
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleQrcode(row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SMS.googleQrCode")) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasPermissionEx("forceLogoff"),
                                      expression:
                                        "hasPermissionEx('forceLogoff')"
                                    }
                                  ],
                                  attrs: {
                                    round: _vm.$store.getters.roundConf,
                                    type: "info",
                                    size: "mini",
                                    icon: "el-icon-error",
                                    plain: _vm.$store.getters.plainConf
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleForceLogoff(
                                        row.id,
                                        row.agentName
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("SMS.forceLogoffText")) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasViewPermission,
                      expression: "hasViewPermission"
                    }
                  ],
                  attrs: {
                    total: _vm.total,
                    page: _vm.listQuery.pageNum,
                    limit: _vm.listQuery.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.listQuery, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.listQuery, "pageSize", $event)
                    },
                    pagination: _vm.getList
                  }
                })
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dialog" },
        [
          _c(
            "el-dialog",
            {
              attrs: {
                id: "dialog",
                visible: _vm.dialogFormVisible,
                width: "700px"
              },
              on: {
                "update:visible": function($event) {
                  _vm.dialogFormVisible = $event
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "card" },
                [
                  _c("div", { staticClass: "card-title" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.textMap[_vm.dialogType]) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "close" }, [
                      _c("i", {
                        staticClass: "el-icon-close",
                        on: {
                          click: function($event) {
                            _vm.dialogFormVisible = false
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.formLoading,
                          expression: "formLoading"
                        }
                      ],
                      ref: "dataForm",
                      attrs: {
                        rules: _vm.rules,
                        model: _vm.formTemp,
                        "label-position": "left",
                        "label-width": "220px"
                      }
                    },
                    [
                      _vm.dialogType === "create" && _vm.$store.getters.isAdmin
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SMS.upAgentId"),
                                prop: "upAgentId"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "filter-item",
                                  attrs: {
                                    placeholder: _vm.$t("option.pleaseChoose"),
                                    clearable: "",
                                    filterable: ""
                                  },
                                  model: {
                                    value: _vm.formTemp.upAgentId,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formTemp, "upAgentId", $$v)
                                    },
                                    expression: "formTemp.upAgentId"
                                  }
                                },
                                _vm._l(_vm.upAgentOption, function(item) {
                                  return _c("el-option", {
                                    key: item.agentId,
                                    attrs: {
                                      label: item.agentName,
                                      value: item.agentId
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SMS.agentName"),
                            prop: "agentName"
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formTemp.agentName,
                              callback: function($$v) {
                                _vm.$set(_vm.formTemp, "agentName", $$v)
                              },
                              expression: "formTemp.agentName"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SMS.agentAccount"),
                            prop: "agentAccount"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.dialogType !== "create" },
                            model: {
                              value: _vm.formTemp.agentAccount,
                              callback: function($$v) {
                                _vm.$set(_vm.formTemp, "agentAccount", $$v)
                              },
                              expression: "formTemp.agentAccount"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.dialogType === "create"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SMS.password"),
                                prop: "agentPassword"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "password",
                                  "show-password": ""
                                },
                                model: {
                                  value: _vm.formTemp.agentPassword,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formTemp, "agentPassword", $$v)
                                  },
                                  expression: "formTemp.agentPassword"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.dialogType === "create"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SMS.confirmPassword"),
                                prop: "checkPassword"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "password",
                                  "show-password": ""
                                },
                                model: {
                                  value: _vm.formTemp.checkPassword,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formTemp, "checkPassword", $$v)
                                  },
                                  expression: "formTemp.checkPassword"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.dialogType === "create"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SMS.payPassword"),
                                prop: "payPassword"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "password",
                                  "show-password": ""
                                },
                                model: {
                                  value: _vm.formTemp.payPassword,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formTemp, "payPassword", $$v)
                                  },
                                  expression: "formTemp.payPassword"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SMS.phoneNumber"),
                            prop: "phoneNumber"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              oninput:
                                "javascript:this.value=this.value.replace(/\\D/g,'')"
                            },
                            model: {
                              value: _vm.formTemp.phoneNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.formTemp, "phoneNumber", $$v)
                              },
                              expression: "formTemp.phoneNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SMS.email"), prop: "email" }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formTemp.email,
                              callback: function($$v) {
                                _vm.$set(_vm.formTemp, "email", $$v)
                              },
                              expression: "formTemp.email"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "QQ:", prop: "qq" } },
                        [
                          _c("el-input", {
                            attrs: {
                              oninput:
                                "javascript:this.value=this.value.replace(/\\D/g,'')"
                            },
                            model: {
                              value: _vm.formTemp.qq,
                              callback: function($$v) {
                                _vm.$set(_vm.formTemp, "qq", $$v)
                              },
                              expression: "formTemp.qq"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.dialogType === "update"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SMS.status"),
                                prop: "stateCode"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "filter-item",
                                  attrs: { filterable: "", clearable: "" },
                                  model: {
                                    value: _vm.formTemp.stateCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formTemp, "stateCode", $$v)
                                    },
                                    expression: "formTemp.stateCode"
                                  }
                                },
                                _vm._l(_vm.statusOptions, function(option) {
                                  return _c("el-option", {
                                    key: option.key,
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "option.pleaseChoose"
                                      ),
                                      label: option.display_name,
                                      value: option.key
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SMS.forceBindGoogleText") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "filter-item",
                              attrs: { filterable: "", clearable: "" },
                              model: {
                                value: _vm.formTemp.isGoogle,
                                callback: function($$v) {
                                  _vm.$set(_vm.formTemp, "isGoogle", $$v)
                                },
                                expression: "formTemp.isGoogle"
                              }
                            },
                            _vm._l(_vm.forceBindGoogleOption, function(option) {
                              return _c("el-option", {
                                key: option.key,
                                attrs: {
                                  placeholder: _vm.$t("option.pleaseChoose"),
                                  label: option.display_name,
                                  value: option.key
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SMS.description"),
                            prop: "description"
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formTemp.description,
                              callback: function($$v) {
                                _vm.$set(_vm.formTemp, "description", $$v)
                              },
                              expression: "formTemp.description"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SMS.remark"), prop: "remark" }
                        },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea" },
                            model: {
                              value: _vm.formTemp.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.formTemp, "remark", $$v)
                              },
                              expression: "formTemp.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "confirm-button" },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.dialogFormVisible = false
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("common.cancel")) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.formLoading,
                              expression: "formLoading"
                            }
                          ],
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.dialogType === "create"
                                ? _vm.doCreateData()
                                : _vm.doUpdateData()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("common.confirm")) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dialog" },
        [
          _c(
            "el-dialog",
            {
              attrs: {
                id: "copyCostdialog",
                visible: _vm.copyCostDialogVisible,
                width: "700px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  _vm.copyCostDialogVisible = $event
                },
                closed: function($event) {
                  _vm.copyCostDialogVisible = false
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "card" },
                [
                  _c("div", { staticClass: "card-title" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("agent.copyAgentCostText")) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "close" }, [
                      _c("i", {
                        staticClass: "el-icon-close",
                        on: {
                          click: function($event) {
                            _vm.copyCostDialogVisible = false
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    {
                      ref: "copyCost",
                      attrs: {
                        model: _vm.copyCostParameter,
                        "label-width": "220px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("agent.sourceAgentNameText") }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "filter-item",
                              attrs: {
                                placeholder: _vm.$t("option.pleaseChoose"),
                                clearable: "",
                                filterable: ""
                              },
                              model: {
                                value: _vm.copyCostParameter.sourceAgentId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.copyCostParameter,
                                    "sourceAgentId",
                                    $$v
                                  )
                                },
                                expression: "copyCostParameter.sourceAgentId"
                              }
                            },
                            _vm._l(_vm.agentOption, function(item) {
                              return _c("el-option", {
                                key: item.agentId,
                                attrs: {
                                  label: item.agentName,
                                  value: item.agentId
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("agent.targetAgentNameText") }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "filter-item",
                              attrs: {
                                placeholder: _vm.$t("option.pleaseChoose"),
                                multiple: "",
                                clearable: "",
                                filterable: ""
                              },
                              model: {
                                value: _vm.copyCostParameter.targetAgentId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.copyCostParameter,
                                    "targetAgentId",
                                    $$v
                                  )
                                },
                                expression: "copyCostParameter.targetAgentId"
                              }
                            },
                            _vm._l(_vm.agentOption, function(item) {
                              return _c("el-option", {
                                key: item.agentId,
                                attrs: {
                                  label: item.agentName,
                                  value: item.agentId
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("common.remark") } },
                        [
                          _c("span", [
                            _vm._v(
                              "\n               " +
                                _vm._s(
                                  _vm.$t("warningMessage.copyAgentCostRemark")
                                ) +
                                "\n              "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "confirm-button" },
                    [
                      _c(
                        "el-button",
                        { on: { click: _vm.handleResetCopyCost } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("common.reset")) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleCopyCost }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("common.submit")) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "agent-dialog" },
        [
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.$t("SMS.updateRolePermissions"),
                "close-on-click-modal": (_vm.boolTrue = false),
                visible: _vm.dialogTreeVisible,
                width: "400px"
              },
              on: {
                "update:visible": function($event) {
                  _vm.dialogTreeVisible = $event
                },
                close: _vm.handleResetTree
              }
            },
            [
              _c("div", { staticClass: "tree-diagram" }, [
                _c("div", { staticClass: "text" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("SMS.rolePermissions")) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "scrollbar" },
                  [
                    _c(
                      "el-scrollbar",
                      { attrs: { "wrap-class": "scrollbar-wrapper" } },
                      [
                        _c("el-tree", {
                          ref: "tree",
                          attrs: {
                            data: _vm.permissionTree,
                            "show-checkbox": "",
                            "node-key": "id",
                            "highlight-current": "",
                            props: _vm.defaultProps,
                            "check-strictly": ""
                          },
                          on: { check: _vm.handleCheck }
                        }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: { float: "right" },
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.doPermissionUpdate()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("common.confirm")) +
                                "\n            "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "agent-dialog" },
        [
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.$t("SMS.bingQrcode"),
                visible: _vm.dialogQrcodeVisible,
                width: "330px",
                center: true
              },
              on: {
                "update:visible": function($event) {
                  _vm.dialogQrcodeVisible = $event
                }
              }
            },
            [
              _c("el-container", {
                staticStyle: { width: "400px", "margin-left": "20px" },
                attrs: { id: "qrcode" }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "el-dialog__footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.dialogQrcodeVisible = false
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("common.confirm")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }